import Ripple from "../../components/Ripple";
import React from "react";
import MaterialIcons from "./materialIcons";
import { notification } from "antd";
import { SvgTriple_mix, SvgDouble_mix, SvgHot, SvgDrop, SvgGift, SvgHelp, SvgMenu, SvgBlank, SvgExit, SvgDownload, SvgPicture, SvgSave, SvgDelete, SvgType_1, SvgType_2, SvgType_3, SvgType_4, SvgEdit, SvgShare, SvgUser_outline, SvgUser, SvgLike, SvgMenu_square, SvgId, SvgChat, SvgAdd, SvgSetting, SvgLinkedIn, SvgYoutube, SvgAddressBook,
  SvgFlagBg, SvgFlagDe, SvgFlagDk, SvgFlagEe, SvgFlagEs, SvgFlagFi, SvgFlagFr, SvgFlagGb, SvgFlagGr, SvgFlagHr, SvgFlagHu, SvgFlagIt, SvgFlagLt, SvgFlagNl, SvgFlagPl, SvgFlagPt, SvgFlagRo, SvgFlagSi, SvgFlagSr, SvgFlagSv,
  SvgArrowUp,
  SvgArrowDown,
  SvgTutorialsVideo,
  SvgVersions,
  SvgCgu,
  SvgSatification,
  SvgSquareBolt,
  SvgInfo,
  SvgEtap1,
  SvgEtap5,
  SvgSupprimer,
  SvgCommandEdit,
  SvgCommandDuplicate,
  SvgCommandReport,
  SvgCommandEmail,
  SvgCommandDownload,
  SvgWarning,
  SvgClose,
  SvgChevronDown,
  SvgChevronUp,
  SvgMaisonSeule,
  SvgMaison1mur,
  SvgMaison2murs,
  SvgMaisonR1,
  SvgSuccess,
  SvgCoefficient,
  SvgDpe,
  SvgFacture,
  SvgDeperditions,
  SvgEnSavoir,
  SvgArrow,
  SvgCommandAdd,
  SvgFacebook,
  SvgPinterest,
  SvgFacebookWidget,
  SvgYoutubeWidget,
  SvgLinkedInWidget,
  SvgPinterestWidget,
  SvgAerothermie,
  SvgGeothermie,
  SvgSolutionHybrides,
  SvgSans,
  SvgIntegree,
  SvgDeportee,
  SvgInstantanee,
  SvgContrast,
  SvgInfoOutline,
  SvgLikeOutline,
  SvgEconomique,
  SvgCirclePlus,
  SvgPointer,
  SvgClock,
  SvgSuccessInvert,
  SvgDocumentDownload,
  SvgSaveProject,
  SvgArrowLeft,
  SvgExcelDownload,
  SvgAddNote,
  SvgCommandSearch,
  SvgErrorInfo,
  SvgSuccessWhiteTransparent,
  SvgOrderByAsc,
  SvgOrderByDesc,
  SvgOrderByAscActive,
  SvgOrderByDescActive
 } from "components/svg";

 const Project_Icons = [
    { name: "group_1", icons: [
      { name: "SvgMenu_square" , icon: <SvgMenu_square />},
      { name: "SvgLike" , icon: <SvgLike />},
      { name: "SvgUser" , icon: <SvgUser />},
      { name: "SvgUser_outline" , icon: <SvgUser_outline />},
      { name: "SvgId" , icon: <SvgId />},
      { name: "SvgChat" , icon: <SvgChat />},
      { name: "SvgAdd" , icon: <SvgAdd />},
      { name: "SvgSetting" , icon: <SvgSetting />},
      { name: "SvgType_1" , icon: <SvgType_1 />},
      { name: "SvgType_2" , icon: <SvgType_2 />},
      { name: "SvgType_3" , icon: <SvgType_3 />},
      { name: "SvgType_4" , icon: <SvgType_4 />},
      { name: "SvgWarning" , icon: <SvgWarning />},
      { name: "SvgClose" , icon: <SvgClose />},
      { name: "SvgHot" , icon: <SvgHot />},
      { name: "SvgDrop" , icon: <SvgDrop />},
      { name: "SvgTriple_mix" , icon: <SvgTriple_mix />},
      { name: "SvgDouble_mix" , icon: <SvgDouble_mix />},
      { name: "SvgGift" , icon: <SvgGift />},
      { name: "SvgHelp" , icon: <SvgHelp />},
      { name: "SvgMenu" , icon: <SvgMenu />},
      { name: "SvgPicture" , icon: <SvgPicture />},
      { name: "SvgSave" , icon: <SvgSave />},
      { name: "SvgSaveProject" , icon: <SvgSaveProject />},
      { name: "SvgShare" , icon: <SvgShare />},
    ]},
    { name: "group_2", icons: [
      { name: "SvgLinkedIn" , icon: <SvgLinkedIn />},
      { name: "SvgLinkedInWidget" , icon: <SvgLinkedInWidget />},
      { name: "SvgYoutube" , icon: <SvgYoutube />},
      { name: "SvgYoutubeWidget" , icon: <SvgYoutubeWidget />},
      { name: "SvgFacebook" , icon: <SvgFacebook />},
      { name: "SvgFacebookWidget" , icon: <SvgFacebookWidget />},
      { name: "SvgPinterest" , icon: <SvgPinterest />},
      { name: "SvgPinterestWidget" , icon: <SvgPinterestWidget />},
      { name: "SvgAddressBook" , icon: <SvgAddressBook />},
      { name: "SvgSquareBolt" , icon: <SvgSquareBolt />},
      { name: "SvgArrowUp" , icon: <SvgArrowUp />},
      { name: "SvgArrowDown" , icon: <SvgArrowDown />},
      { name: "SvgArrowLeft" , icon: <SvgArrowLeft />},
      { name: "SvgArrow" , icon: <SvgArrow />},
      { name: "SvgChevronUp" , icon: <SvgChevronUp />},
      { name: "SvgChevronDown" , icon: <SvgChevronDown />},
      { name: "SvgMaisonSeule" , icon: <SvgMaisonSeule />},
      { name: "SvgMaison1mur" , icon: <SvgMaison1mur />},
      { name: "SvgMaison2murs" , icon: <SvgMaison2murs />},
      { name: "SvgMaisonR1" , icon: <SvgMaisonR1 />},
      { name: "SvgAerothermie" , icon: <SvgAerothermie />},
      { name: "SvgGeothermie" , icon: <SvgGeothermie />},
      { name: "SvgSolutionHybrides" , icon: <SvgSolutionHybrides />},
      { name: "SvgSans" , icon: <SvgSans />},
      { name: "SvgIntegree" , icon: <SvgIntegree />},
      { name: "SvgDeportee" , icon: <SvgDeportee />},
      { name: "SvgInstantanee" , icon: <SvgInstantanee />},

      { name: "SvgCoefficient" , icon: <SvgCoefficient />},
      { name: "SvgDpe" , icon: <SvgDpe />},
      { name: "SvgFacture" , icon: <SvgFacture />},
      { name: "SvgDeperditions" , icon: <SvgDeperditions />},
      { name: "SvgEnSavoir" , icon: <SvgEnSavoir />},
    ]},
    { name: "group_3", icons: [
      { name: "SvgTutorialsVideo" , icon: <SvgTutorialsVideo />},
      { name: "SvgVersions" , icon: <SvgVersions />},
      { name: "SvgCgu" , icon: <SvgCgu />},
      { name: "SvgSatification" , icon: <SvgSatification />},
      { name: "SvgInfo" , icon: <SvgInfo />},
      { name: "SvgErrorInfo" , icon: <SvgErrorInfo />},
      { name: "SvgEtap1" , icon: <SvgEtap1 />},
      { name: "SvgEtap5" , icon: <SvgEtap5 />},
      { name: "SvgSuccess" , icon: <SvgSuccess />},
      { name: "SvgSuccessInvert" , icon: <SvgSuccessInvert />},
      { name: "SvgSuccessWhiteTransparent" , icon: <SvgSuccessWhiteTransparent />},
      { name: "SvgContrast" , icon: <SvgContrast />},
      { name: "SvgInfoOutline" , icon: <SvgInfoOutline />},
      { name: "SvgLikeOutline" , icon: <SvgLikeOutline />},
      { name: "SvgEconomique" , icon: <SvgEconomique />},
      { name: "SvgCirclePlus" , icon: <SvgCirclePlus />},
      { name: "SvgSupprimer" , icon: <SvgSupprimer/>},
      { name: "SvgCommandAdd" , icon: <SvgCommandAdd />},
      { name: "SvgCommandEdit" , icon: <SvgCommandEdit />},
      { name: "SvgCommandSearch" , icon: <SvgCommandSearch />},
      { name: "SvgAddNote" , icon: <SvgAddNote />},
      { name: "SvgCommandDuplicate" , icon: <SvgCommandDuplicate />},
      { name: "SvgCommandReport" , icon: <SvgCommandReport />},
      { name: "SvgCommandEmail" , icon: <SvgCommandEmail />},
      { name: "SvgCommandDownload" , icon: <SvgCommandDownload />},
      { name: "SvgDocumentDownload" , icon: <SvgDocumentDownload />},
      { name: "SvgExcelDownload" , icon: <SvgExcelDownload />},
      { name: "SvgPointer" , icon: <SvgPointer />},
      { name: "SvgClock" , icon: <SvgClock />},
      { name: "SvgOrderByAsc" , icon: <SvgOrderByAsc />},
      { name: "SvgOrderByDesc" , icon: <SvgOrderByDesc />},
      { name: "SvgOrderByAscActive" , icon: <SvgOrderByAscActive />},
      { name: "SvgOrderByDescActive" , icon: <SvgOrderByDescActive />},
    ]},
    { name: "group_4", icons: [
      { name: "SvgFlagBg" , icon: <SvgFlagBg />},
      { name: "SvgFlagDe" , icon: <SvgFlagDe />},
      { name: "SvgFlagDk" , icon: <SvgFlagDk />},
      { name: "SvgFlagEe" , icon: <SvgFlagEe />},
      { name: "SvgFlagEs" , icon: <SvgFlagEs />},
      { name: "SvgFlagFi" , icon: <SvgFlagFi />},
      { name: "SvgFlagFr" , icon: <SvgFlagFr />},
      { name: "SvgFlagGb" , icon: <SvgFlagGb />},
      { name: "SvgFlagGr" , icon: <SvgFlagGr />},
      { name: "SvgFlagHr" , icon: <SvgFlagHr />},
      { name: "SvgFlagHu" , icon: <SvgFlagHu />},
      { name: "SvgFlagIt" , icon: <SvgFlagIt />},
      { name: "SvgFlagLt" , icon: <SvgFlagLt />},
      { name: "SvgFlagNl" , icon: <SvgFlagNl />},
      { name: "SvgFlagPl" , icon: <SvgFlagPl />},
      { name: "SvgFlagPt" , icon: <SvgFlagPt />},
      { name: "SvgFlagRo" , icon: <SvgFlagRo />},
      { name: "SvgFlagSi" , icon: <SvgFlagSi />},
      { name: "SvgFlagSr" , icon: <SvgFlagSr />},
      { name: "SvgFlagSv" , icon: <SvgFlagSv />},
    ]},
    // { name: "group_5", icons: [
    //   { name: "" , icon: <></>},
    //   { name: "" , icon: <></>},
    //   { name: "" , icon: <></>},
    //   { name: "" , icon: <></>},

    // ]},
    
 ]

const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
  const value = event.target.value.toLowerCase();
  const parentContainers = document.querySelectorAll("grid");

  parentContainers.forEach((parentContainer) => {
    let anyItemsToShow = false;
    const items = parentContainer.querySelectorAll("[data-name='icon-demo']");

    items.forEach((item) => {
      const text = item.textContent || ""; //NOSONAR
      const shouldShow = text.toLowerCase().includes(value);

      if (item instanceof HTMLElement) {
        if (shouldShow) {
          item.style.display = "";
          anyItemsToShow = true;
        } else {
          item.style.display = "none";
        }
      }
    });

    if (parentContainer instanceof HTMLElement) {
      parentContainer.style.display = anyItemsToShow ? "" : "none";
    }
  });
};

const Icons: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();
  const handleIconClick = (iconName: string, icon: any) => {
    const key = "updatable";
    
    navigator.clipboard
      .writeText(iconName)
      .then(() => {
        api.open({
          closeIcon:false,
          duration: 3,
          placement: "bottomRight",
          
          
          
        
          key,
          message: (
            <group
              data-direction="row"
              data-wrap="no"
              data-gap="15"
              data-space="10"
              data-align="center"
              data-text-align="left"
            >
              <icon data-icon-size="mini" data-length="30">{icon}</icon>
              <separator data-vertical="" data-height="40"></separator>
              <group data-direction="column" data-gap="5">
                <text data-weight="700">{iconName}</text>
                <text>Icon name copied to clipboard</text>
              </group>
            </group>
          ),
        });
       // console.log("Icon name copied to clipboard:", iconName);
      })
      .catch((error) => {
        console.error("Failed to copy icon name to clipboard:", error);
      });

  };
  return (
    <view>
{contextHolder}
      <view data-vertical="true">
        <view data-scroll="" data-space="15">
          <group data-direction="column" data-gap="15" data-space="20">
            <text data-weight="700" data-text-size="xxx-large" data-wrap="wrap" data-color="main">Material Symbols</text>
            <text data-wrap="wrap" data-length="610" data-line="1.5" data-light="" >
              Material Symbols consolidating over <b>3,275</b> glyphs in a single font file with a wide range of design variants.
              Symbols are available in three styles and four adjustable variable font styles (fill, weight, grade, and optical size).
            </text>
          </group>
          <group
            data-sticky="top"
            data-space="20"
            data-width="auto"

          >
            <group data-length="400" data-radius="10" data-elevation="1" data-align="center" data-backdrop=""
              data-contain=""
              data-shrink="no" >
              <Ripple>
                <label  //NOSONAR
                  className="field"
                  data-label="left"

                  data-multi-element=""
                  data-length="autofit"
                  data-space-horizontal="10"
                >
                  <div className="form_fields">
                    <div className="field_cont">
                      <icon data-space="5">search</icon>
                      <separator data-vertical="" data-margin="10"></separator>
                      <input

                        className="icon_search"
                        placeholder="Search..."
                        onChange={handleSearch}
                      />

                    </div>
                  </div>
                </label>
              </Ripple>
            </group>
          </group>

          <group>
            <grid>
              <group
                data-align="center"
                //  data-border="overprint"
                data-space-horizontal="10"
              //  data-sticky="top"
              //  data-backdrop=""
              >
                <text data-weight="700" data-space="10" data-ellipsis="">
                  Material Icons Demo
                </text>
                <separator data-vertical=""></separator>
                <a
                  data-link=""
                  target="_blank"
                  rel="noreferrer"
                  href="https://fonts.google.com/icons?icon.style=Rounded"
                >

                  <text data-weight="700" data-space="10" data-ellipsis="">
                    More icons ...
                  </text>
                </a>
              </group>

              <group data-space="10">
                <group
                  data-space="10"
                  data-type="grid"
                  data-gap="10"
                  data-grid-template="110"
                  data-contain=""
                // data-border=""
                // data-radius="10"
                >
                  <MaterialIcons></MaterialIcons>
                </group>
              </group>
            </grid>
          </group>


        </view>
        <view data-scroll="" data-space="15">
          <grid>
            <group
              data-align="center"
              // data-border="overprint"
              data-space-horizontal="10"
            //  data-sticky="top"
            //  data-backdrop=""
            >
              <text data-weight="700" data-space="10" data-ellipsis="">
                Filled & Colored Icons
              </text>
            </group>

            <group data-space="10">
              <group
                data-space="10"
                data-type="grid"
                data-gap="10"
                data-grid-template="110"
                data-contain=""
              >
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="">apparel</icon> <text data-ellipsis="">Apparel</text> </group> </group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="">star</icon> <text data-ellipsis="">Star</text> </group> </group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="">local_pizza</icon> <text data-ellipsis="">Pizza</text> </group> </group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="" data-color="amber">folder</icon> <text>Folder</text> </group> </group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="" data-color="red"> favorite </icon> <text>Heart</text> </group> </group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1" > <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-fill="" data-color="light-green">nest_eco_leaf</icon> <text>Leaf</text> </group> </group>
              </group>
            </group>
          </grid>

          <grid>
            <group data-align="center"
              //  data-border="overprint"
              data-space-horizontal="10"
            //    data-sticky="top"
            //   data-backdrop=""
            > <text data-weight="700" data-space="10" data-ellipsis=""> Icon Weight </text> </group>

            <group data-space="10">
              <group
                data-space="10"
                data-type="grid"
                data-gap="10"
                data-grid-template="110"
                data-contain=""
              >
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="100">nest_eco_leaf </icon> <text data-light="">Leaf - 100</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="200">nest_eco_leaf </icon> <text data-light="">Leaf - 200</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="300">nest_eco_leaf </icon> <text data-light="">Leaf - 300</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="">   nest_eco_leaf </icon> <text data-light="">Leaf - 400</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="500">nest_eco_leaf </icon> <text data-light="">Leaf - 500</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="600">nest_eco_leaf </icon> <text data-light="">Leaf - 600</text> </group></group>
                <group data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1"><group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" > <icon data-icon-size="mini" data-icon-weight="700">nest_eco_leaf </icon> <text data-light="">Leaf - 700</text> </group></group>
              </group>
            </group>
          </grid>
        </view>
        <view data-scroll="" data-space="15">
          <grid>
            <group data-align="center" data-space-horizontal="10"> <text data-weight="700" data-space="10" data-ellipsis="">Custom SVG Icons (24px)</text> </group>



          { Project_Icons.map((group: any) => {
                return (
                  <group key={group.name} data-space="10">
                    <group data-space="10" data-type="grid" data-gap="10" data-grid-template="120" data-contain="">
                    {
                          group?.icons?.map((item: any) => {
                          return (
                            <group onClick={()=>handleIconClick(item.name, item.icon)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                              <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                                <icon 
                                  data-svg-size="24" 
                                  data-svg-color="main" 
>
                                  {item.icon}
                                </icon>
                                <text data-light="" data-ellipsis="">{item.name}</text>
                              </group>
                            </group>
                          )
                        })
                      }
                    </group>
                  </group>
                )
              })
            }
              
           

            {/* new */}


            <group data-space="10">
              <group data-align="center" data-space-horizontal="10"> <text data-weight="700" data-space="10" data-ellipsis="">Custom SVG Icons  (16px)</text> </group>
              <group data-space="10" data-type="grid" data-gap="10" data-grid-template="120" data-contain="">

                <group onClick={()=>handleIconClick("SvgBlank", <SvgBlank />)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                  <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                    <icon data-svg-size="16" data-svg-color="main">
                      <SvgBlank />
                    </icon>
                    <text data-light="" data-ellipsis="">SvgBlank</text>
                  </group>
                </group>
                <group onClick={()=>handleIconClick("SvgExit", <SvgExit />)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                  <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                    <icon data-svg-size="16" data-svg-color="main">
                      <SvgExit />
                    </icon>
                    <text data-light="" data-ellipsis="">SvgExit</text>
                  </group>
                </group>
                <group onClick={()=>handleIconClick("SvgDownload", <SvgDownload />)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                  <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                    <icon data-svg-size="16" data-svg-color="main">
                      <SvgDownload />
                    </icon>
                    <text data-light="" data-ellipsis="">SvgDownload</text>
                  </group>
                </group>
                <group onClick={()=>handleIconClick("SvgDelete", <SvgDelete />)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                  <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                    <icon data-svg-size="16" data-svg-color="main">
                      <SvgDelete />
                    </icon>
                    <text data-light="" data-ellipsis="">SvgDelete</text>
                  </group>
                </group>
                <group onClick={()=>handleIconClick("SvgEdit", <SvgEdit />)} data-radius="10" data-name="icon-demo" data-contain="" data-interactive="" data-background="main-background" data-border="outline" data-space="15" data-cursor="pointer" data-ratio="1:1">
                  <group data-index="1" data-justify="center" data-align="center" data-gap="20" data-direction="column" >
                    <icon data-svg-size="16" data-svg-color="main">
                      <SvgEdit />
                    </icon>
                    <text data-light="" data-ellipsis="">SvgEdit</text>
                  </group>
                </group>

              </group>
            </group>
          </grid>
        </view>
      </view>
    </view>
  );
};
export default Icons;
